export enum EcclesiasticalFunction {
    MEMBER = 1,
    LABORERS = 100,
    MINISTERS = 101,
    DEACONS = 102
}